<div class="flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto px-5 py-7 sm:px-8 sm:pt-12">
  <div class="flex flex-col gap-3">
    <h1 class="use-grotesque m-0 text-4xl font-bold leading-none tracking-tight text-balance sm:text-5xl">
      Where should creators <span class="text-primary">post?</span>
    </h1>
    <p class="m-0 text-xl font-semibold leading-snug text-muted-foreground">Pick one or more. We'll match creators who are strongest on each.</p>
  </div>

  <div class="grid grid-cols-2 gap-3" role="group" aria-label="Where should creators post?">
    @for (network of brief.networks; track network.id) {
      <button type="button" class="relative flex min-h-24 flex-col justify-center rounded-xl p-4 text-left" [class]="tileClass(network.id)" [attr.aria-pressed]="brief.networkSelected(network.id)" (click)="brief.toggleNetwork(network.id)">
        <span class="absolute right-3 top-3 flex size-5 items-center justify-center rounded-md border" [class]="brief.networkSelected(network.id) ? 'border-primary bg-primary text-primary-foreground' : 'border-muted-foreground'" aria-hidden="true">
          @if (brief.networkSelected(network.id)) {
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" class="size-3"><path d="M20 6 9 17l-5-5" /></svg>
          }
        </span>
        <span class="block text-xl font-bold">{{ network.name }}</span>
        <span class="block text-sm font-semibold text-muted-foreground">{{ network.formats }}</span>
      </button>
    }
  </div>

  @if (brief.error()) {
    <p class="m-0 text-base font-semibold text-red-600" role="alert">{{ brief.error() }}</p>
  }

</div>
<div class="shrink-0 border-t border-border bg-background px-5 py-3 sm:px-8">
  <button type="button" class="btn-shout btn-shout-md btn-shout-primary w-full" (click)="brief.continueFromNetwork()">Generate my brief</button>
</div>
